import React, { useState } from "react";
import sprintBoot from "../assets/spring-boot.png";
import k8 from "../assets/kubernetes.png";
import django from "../assets/django-python-logo.png";
import jScript from "../assets/Javascript.png";
import Azure from "../assets/Azure.png";
import gcp from "../assets/gcp.png";
import node from "../assets/node.png";
import python from "../assets/python.png";
import typescript from "../assets/typescript.png";
import react from "../assets/React-icon.svg.png";
import aws from "../assets/aws.png";
import docker from "../assets/docker.png";
import github from "../assets/github.png";
import gitlab from "../assets/gitlab.png";
import jenkins from "../assets/jenkins.png";
import golang from "../assets/golang.png";
import mongodb from "../assets/mongodb.png";
import mysql from "../assets/mysql.png"
import postgrsql from "../assets/postgress.png"
import ansible from "../assets/ansible.png"
import terraform from "../assets/terraform.png"


const Experience = () => {
  const [expandedCategories, setExpandedCategories] = useState({});

  // Tech usage frequency from work experience
  const techUsage = {
    "React": 2,
    "JavaScript": 1,
    "TypeScript": 2,
    "Node.js": 1,
    "Spring Boot": 1,
    "Django": 1,
    "Python": 4,
    "Golang": 1,
    "AWS": 3,
    "Azure": 1,
    "GCP": 1,
    "Docker": 3,
    "Kubernetes": 3,
    "Terraform": 3,
    "Ansible": 1,
    "Jenkins": 2,
    "GitHub": 1,
    "GitLab": 1,
    "MongoDB": 1,
    "MySQL": 1,
    "PostgreSQL": 1,
  };

  const toggleCategory = (categoryIndex) => {
    setExpandedCategories(prev => ({
      ...prev,
      [categoryIndex]: !prev[categoryIndex]
    }));
  };

  const techCategories = [
    {
      category: "Frontend",
      description: "Built responsive and interactive user interfaces for web applications",
      techs: [
    {
      id: 1,
      src: react,
      title: "React",
          description: "Built dynamic UIs",
      style: "shadow-blue-500",
    },
    {
      id: 3,
          src: jScript,
          title: "JavaScript",
          description: "Frontend & scripting",
          style: "shadow-yellow-500",
    },
    {
      id: 4,
          src: typescript,
          title: "TypeScript",
          description: "Type-safe development",
          style: "shadow-blue-500",
    },
      ],
    },
    {
      category: "Backend",
      description: "Developed scalable APIs, microservices, and server-side applications",
      techs: [
    {
      id: 5,
      src: node,
          title: "Node.js",
          description: "API & microservices",
      style: "shadow-green-500",
    },
    {
      id: 6,
          src: sprintBoot,
          title: "Spring Boot",
          description: "Java microservices",
          style: "shadow-green-500",
    },
    {
      id: 7,
          src: django,
          title: "Django",
          description: "Python web apps",
          style: "shadow-green-500",
    },
    {
      id: 8,
          src: python,
          title: "Python",
          description: "Automation & APIs",
          style: "shadow-yellow-500",
    },
    {
      id: 9,
          src: golang,
          title: "Golang",
          description: "High-performance services",
          style: "shadow-blue-500",
    },
      ],
    },
    {
      category: "Cloud",
      description: "Deployed and managed applications across multiple cloud platforms",
      techs: [
    {
      id: 10,
          src: aws,
          title: "AWS",
          description: "Infrastructure & services",
          style: "shadow-orange-500",
    },
    {
      id: 11,
          src: Azure,
          title: "Azure",
          description: "Cloud deployments",
      style: "shadow-blue-500",
    },
    {
      id: 12,
          src: gcp,
          title: "GCP",
          description: "Cloud solutions",
          style: "shadow-rose-500",
    },
      ],
    },
    {
      category: "DevOps",
      description: "Automated deployments, infrastructure provisioning, and CI/CD pipelines",
      techs: [
    {
      id: 13,
          src: docker,
          title: "Docker",
          description: "Containerized apps",
          style: "shadow-blue-500",
    },
    {
      id: 14,
          src: k8,
          title: "Kubernetes",
          description: "Orchestrated clusters",
          style: "shadow-blue-500",
    },
    {
      id: 15,
      src: terraform,
      title: "Terraform",
          description: "Infrastructure as code",
      style: "shadow-violet-500",
    },
    {
      id: 16,
      src: ansible,
      title: "Ansible",
          description: "Configuration management",
      style: "shadow-rose-500",
    },
    {
      id: 17,
          src: jenkins,
          title: "Jenkins",
          description: "CI/CD pipelines",
          style: "shadow-rose-500",
    },
    {
      id: 18,
          src: github,
          title: "GitHub",
          description: "Code & CI/CD",
          style: "shadow-gray-500",
        },
    {
      id: 19,
          src: gitlab,
          title: "GitLab",
          description: "Version control & CI",
          style: "shadow-red-500",
    },
      ],
    },
    {
      category: "Databases",
      description: "Designed and managed database solutions for data storage and retrieval",
      techs: [
    {
      id: 20,
      src: mongodb,
          title: "MongoDB",
          description: "Document storage",
      style: "shadow-green-500",
    },
    {
      id: 21,
      src: mysql,
          title: "MySQL",
          description: "Relational data",
      style: "shadow-blue-500",
    },
    {
      id: 22,
      src: postgrsql,
          title: "PostgreSQL",
          description: "SQL databases",
      style: "shadow-blue-500",
        },
      ],
    },
  ];
  return (
    <div
      name="experience"
      className="bg-gradient-to-b from-zinc-900 via-slate-950 to-gray-950 w-full py-6 md:py-8 lg:py-10"
    >
      <div className="max-w-screen-lg mx-auto px-6 md:px-8">
        {/* Header */}
        <div className="mb-6">
          <div className="flex items-center gap-3 mb-4">
            <div className="h-1 w-12 bg-blue-500"></div>
            <h3 className="text-2xl md:text-3xl lg:text-4xl font-extrabold tracking-tight text-white">
              Tech Stack
            </h3>
          </div>
          <p className="text-gray-300 text-sm md:text-base lg:text-lg font-light tracking-wide">
            Technologies and tools I have worked with
          </p>
        </div>

        {/* Tech Stack by Categories */}
        {/* Frontend and Backend Side by Side */}
        <div className="grid grid-cols-2 md:grid-cols-2 gap-2 sm:gap-3 md:gap-4 mb-3 sm:mb-4">
          {techCategories.slice(0, 2).map((category, catIndex) => {
            const isExpanded = expandedCategories[catIndex] !== false; // Default to expanded
            const totalTechs = category.techs.length;
            const usedTechs = category.techs.filter(tech => techUsage[tech.title] > 0).length;
            const usagePercentage = (usedTechs / totalTechs) * 100;

            return (
              <div 
                key={catIndex} 
                className="bg-gray-900/40 backdrop-blur-sm rounded-lg border border-gray-700/40 hover:border-blue-500/30 transition-all duration-300 overflow-hidden"
              >
                {/* Category Header - Clickable */}
                <button
                  onClick={() => toggleCategory(catIndex)}
                  className="w-full p-2 md:p-3 flex items-center justify-between group hover:bg-gray-800/30 transition-all duration-300"
    >
                  <div className="flex items-center gap-3 flex-1 text-left">
                    <div className="flex items-center gap-2">
                      <div className="h-0.5 w-8 bg-blue-500"></div>
                      <h4 className="text-xs sm:text-sm md:text-base font-semibold text-gray-300 uppercase tracking-wide">
                        {category.category}
                      </h4>
                    </div>
                    {/* Usage Visualization */}
                    <div className="hidden sm:flex items-center gap-2 ml-4">
                      <div className="relative w-10 h-10">
                        <svg className="transform -rotate-90 w-full h-full" viewBox="0 0 36 36">
                          <circle
                            cx="18"
                            cy="18"
                            r="16"
                            stroke="rgba(55, 65, 81, 0.5)"
                            strokeWidth="3"
                            fill="none"
                          />
                          <defs>
                            <linearGradient id={`gradient-circle-${catIndex}`} x1="0%" y1="0%" x2="100%" y2="100%">
                              <stop offset="0%" stopColor="#3b82f6" />
                              <stop offset="100%" stopColor="#06b6d4" />
                            </linearGradient>
                          </defs>
                          <circle
                            cx="18"
                            cy="18"
                            r="16"
                            stroke={`url(#gradient-circle-${catIndex})`}
                            strokeWidth="3"
                            fill="none"
                            strokeLinecap="round"
                            strokeDasharray={`${2 * Math.PI * 16}`}
                            strokeDashoffset={`${2 * Math.PI * 16 * (1 - usagePercentage / 100)}`}
                            className="transition-all duration-500"
                          />
                        </svg>
                        <div className="absolute inset-0 flex items-center justify-center">
                          <span className="text-[10px] font-bold text-blue-400">{usedTechs}/{totalTechs}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Expand/Collapse Icon */}
                  <div className={`transform transition-transform duration-300 ${isExpanded ? 'rotate-180' : ''}`}>
                    <svg className="w-5 h-5 text-gray-400 group-hover:text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </div>
                </button>

                {/* Category Description */}
                <div className="px-2 md:px-3 pb-2">
                  <p className="text-[10px] sm:text-xs text-gray-400 font-light tracking-wide ml-10">
                    {category.description}
                  </p>
                </div>

                {/* Tech Grid - Collapsible */}
                <div 
                  className={`overflow-hidden transition-all duration-500 ease-in-out ${
                    isExpanded ? 'max-h-[2000px] opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <div className="px-2 md:px-3 pb-2 md:pb-3">
                    <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 sm:gap-3">
                      {category.techs.map(({ id, src, title, description, style }) => {
                        const usageCount = techUsage[title] || 0;
                        const usagePercentage = usageCount > 0 ? (usageCount / 4) * 100 : 0;
                        
                        return (
                          <div
                            key={id}
                            className={`group relative flex flex-col items-center justify-center p-1.5 sm:p-2 rounded-lg bg-gray-900/40 hover:bg-gray-800/50 border border-gray-700/40 hover:border-blue-500/50 transition-all duration-300 hover:scale-105 cursor-pointer backdrop-blur-sm ${style}`}
                          >
                            {/* Usage Indicator */}
                            {usageCount > 0 && (
                              <div className="absolute top-1 right-1 w-3 h-3 bg-green-500 rounded-full border-2 border-gray-900 shadow-lg">
                                <div className="absolute inset-0 bg-green-400 rounded-full animate-ping opacity-75"></div>
                              </div>
                            )}
                            
                            <img 
                              src={src} 
                              alt={title} 
                              className="w-6 h-6 xs:w-7 xs:h-7 sm:w-8 sm:h-8 object-contain mb-1.5 group-hover:scale-110 transition-transform duration-300" 
                            />
                            <p className="text-[9px] xs:text-[10px] text-gray-200 text-center leading-tight group-hover:text-white transition-colors font-semibold tracking-wide mb-0.5">
                              {title}
          </p>
                            <p className="text-[8px] xs:text-[9px] text-gray-400 text-center leading-tight group-hover:text-gray-300 transition-colors font-light">
                              {description}
                            </p>
                            
                            {/* Usage Bar */}
                            {usageCount > 0 && (
                              <div className="w-full mt-1.5 h-1 bg-gray-800/50 rounded-full overflow-hidden">
                                <div 
                                  className="h-full bg-gradient-to-r from-blue-500 to-cyan-500 rounded-full transition-all duration-500"
                                  style={{ width: `${usagePercentage}%` }}
                                ></div>
                              </div>
                            )}
                            
                            {/* Usage Count Tooltip */}
                            {usageCount > 0 && (
                              <div className="absolute -bottom-8 left-1/2 transform -translate-x-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
                                <div className="bg-gray-800 text-white text-[10px] px-2 py-1 rounded shadow-lg whitespace-nowrap">
                                  Used in {usageCount} {usageCount === 1 ? 'role' : 'roles'}
                                </div>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Rest of Categories - Two Columns */}
        <div className="grid grid-cols-2 md:grid-cols-2 gap-2 sm:gap-3 md:gap-4">
          {techCategories.slice(2).map((category, originalIndex) => {
            const catIndex = originalIndex + 2; // Adjust index for expandedCategories
            const isExpanded = expandedCategories[catIndex] !== false; // Default to expanded
            const totalTechs = category.techs.length;
            const usedTechs = category.techs.filter(tech => techUsage[tech.title] > 0).length;
            const usagePercentage = (usedTechs / totalTechs) * 100;

            return (
              <div 
                key={catIndex} 
                className="bg-gray-900/40 backdrop-blur-sm rounded-lg border border-gray-700/40 hover:border-blue-500/30 transition-all duration-300 overflow-hidden"
              >
                {/* Category Header - Clickable */}
                <button
                  onClick={() => toggleCategory(catIndex)}
                  className="w-full p-2 md:p-3 flex items-center justify-between group hover:bg-gray-800/30 transition-all duration-300"
                >
                  <div className="flex items-center gap-3 flex-1 text-left">
                    <div className="flex items-center gap-2">
                      <div className="h-0.5 w-8 bg-blue-500"></div>
                      <h4 className="text-xs sm:text-sm md:text-base font-semibold text-gray-300 uppercase tracking-wide">
                        {category.category}
                      </h4>
                    </div>
                    {/* Usage Visualization */}
                    <div className="hidden sm:flex items-center gap-2 ml-4">
                      <div className="relative w-10 h-10">
                        <svg className="transform -rotate-90 w-full h-full" viewBox="0 0 36 36">
                          <circle
                            cx="18"
                            cy="18"
                            r="16"
                            stroke="rgba(55, 65, 81, 0.5)"
                            strokeWidth="3"
                            fill="none"
                          />
                          <defs>
                            <linearGradient id={`gradient-circle-${catIndex}`} x1="0%" y1="0%" x2="100%" y2="100%">
                              <stop offset="0%" stopColor="#3b82f6" />
                              <stop offset="100%" stopColor="#06b6d4" />
                            </linearGradient>
                          </defs>
                          <circle
                            cx="18"
                            cy="18"
                            r="16"
                            stroke={`url(#gradient-circle-${catIndex})`}
                            strokeWidth="3"
                            fill="none"
                            strokeLinecap="round"
                            strokeDasharray={`${2 * Math.PI * 16}`}
                            strokeDashoffset={`${2 * Math.PI * 16 * (1 - usagePercentage / 100)}`}
                            className="transition-all duration-500"
                          />
                        </svg>
                        <div className="absolute inset-0 flex items-center justify-center">
                          <span className="text-[10px] font-bold text-blue-400">{usedTechs}/{totalTechs}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Expand/Collapse Icon */}
                  <div className={`transform transition-transform duration-300 ${isExpanded ? 'rotate-180' : ''}`}>
                    <svg className="w-5 h-5 text-gray-400 group-hover:text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </div>
                </button>

                {/* Category Description */}
                <div className="px-2 md:px-3 pb-2">
                  <p className="text-[10px] sm:text-xs text-gray-400 font-light tracking-wide ml-10">
                    {category.description}
                  </p>
                </div>

                {/* Tech Grid - Collapsible */}
                <div 
                  className={`overflow-hidden transition-all duration-500 ease-in-out ${
                    isExpanded ? 'max-h-[2000px] opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <div className="px-2 md:px-3 pb-2 md:pb-3">
                    <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 sm:gap-3">
                      {category.techs.map(({ id, src, title, description, style }) => {
                        const usageCount = techUsage[title] || 0;
                        const usagePercentage = usageCount > 0 ? (usageCount / 4) * 100 : 0;
                        
                        return (
            <div
              key={id}
                            className={`group relative flex flex-col items-center justify-center p-1.5 sm:p-2 rounded-lg bg-gray-900/40 hover:bg-gray-800/50 border border-gray-700/40 hover:border-blue-500/50 transition-all duration-300 hover:scale-105 cursor-pointer backdrop-blur-sm ${style}`}
                          >
                            {/* Usage Indicator */}
                            {usageCount > 0 && (
                              <div className="absolute top-1 right-1 w-3 h-3 bg-green-500 rounded-full border-2 border-gray-900 shadow-lg">
                                <div className="absolute inset-0 bg-green-400 rounded-full animate-ping opacity-75"></div>
                              </div>
                            )}
                            
                            <img 
                              src={src} 
                              alt={title} 
                              className="w-6 h-6 xs:w-7 xs:h-7 sm:w-8 sm:h-8 object-contain mb-1.5 group-hover:scale-110 transition-transform duration-300" 
                            />
                            <p className="text-[9px] xs:text-[10px] text-gray-200 text-center leading-tight group-hover:text-white transition-colors font-semibold tracking-wide mb-0.5">
                              {title}
                            </p>
                            <p className="text-[8px] xs:text-[9px] text-gray-400 text-center leading-tight group-hover:text-gray-300 transition-colors font-light">
                              {description}
                            </p>
                            
                            {/* Usage Bar */}
                            {usageCount > 0 && (
                              <div className="w-full mt-1.5 h-1 bg-gray-800/50 rounded-full overflow-hidden">
                                <div 
                                  className="h-full bg-gradient-to-r from-blue-500 to-cyan-500 rounded-full transition-all duration-500"
                                  style={{ width: `${usagePercentage}%` }}
                                ></div>
                              </div>
                            )}
                            
                            {/* Usage Count Tooltip */}
                            {usageCount > 0 && (
                              <div className="absolute -bottom-8 left-1/2 transform -translate-x-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
                                <div className="bg-gray-800 text-white text-[10px] px-2 py-1 rounded shadow-lg whitespace-nowrap">
                                  Used in {usageCount} {usageCount === 1 ? 'role' : 'roles'}
                                </div>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
            </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Experience;
